import React from 'react';
import Layout from '../../components/Layout/Layout';
import AuditLogsView from '../../components/AuditLogs/AuditLogsView';

/**
 * Audit Logs — organization admin view
 * Shows only audit events belonging to the admin's own organization.
 */
const AuditLogs = () => (
  <Layout>
    <div className="p-4 lg:p-6 space-y-4 sm:space-y-6">
      <AuditLogsView mode="admin" />
    </div>
  </Layout>
);

export default AuditLogs;